export default __webpack_public_path__ + "static/media/Gift Annual Subscription.c362f448.jpeg";